import { TileLayer, BitmapLayer, PolygonLayer, H3HexagonLayer, A5Layer } from "deck.gl";

import Legend from "./legend.json";

export class OSMLayer extends TileLayer {
  constructor() {
    super({
      id : 'osm-layer',

      data: [
        'https://tile.openstreetmap.org/{z}/{x}/{y}.png'
      ],

      tileSize: 256,

      renderSubLayers: (props) => {
        const {
          bbox: { west, south, east, north }
        } = props.tile;

        return new BitmapLayer(props, {
          data: null,
          image: props.data,
          bounds: [west, south, east, north],
        });
      }
    });
  };
}

export function renderDataLayer(props) {
  const mixColor = (white, color, areaRatio) => {
    const minKeep = 0.6;
    const t = minKeep + (1 - minKeep) * areaRatio;

    return white + (color - white) * t;
  };

  const getColor = (landuse, areaRatio) => {
    let [r, g, b, a] = Legend[landuse].color;
    const white = 255;

    r = Math.round(mixColor(white, r, areaRatio));
    g = Math.round(mixColor(white, g, areaRatio));
    b = Math.round(mixColor(white, b, areaRatio));

    return [r, g, b, a];
  };

  const getFillColor = (d) => {
      const [landuse, areaRatio] = (props.landuseType === "major")? [d.landuse_major, d.cell_area_ratio] : [props.landuseType, d.landuse_max_area_ratio];

      return getColor(landuse, areaRatio);
  };

  const getElevation = (d) => (props.landuseType === "major")? d.cell_area_ratio * 100 : d.landuse_max_area_ratio * 100;

  const lineColor = [220, 220, 220, 100];

  const layerParam = {
    id: "data-layer",
    data: props.mapData,
    getHexagon: d => d.cell,
    getPentagon: d => d.cell,
    getFillColor: d => getFillColor(d),
    getElevation: d => getElevation(d),
    elevationScale: 200,
    pickable: true,
    filled: true,
    stroked: true,
    wireframe: true,
    getLineColor: lineColor,
    extruded: true,
  };

  const layer = (props.gridType === "h3")? new H3HexagonLayer(layerParam)
        : (props.gridType === "a5")? new A5Layer(layerParam)
        : null;

  return layer;
}

export function renderAllLayers(props) {
  const osmLayer = new OSMLayer();
  const dataLayer = renderDataLayer(props);

  return [
    osmLayer,
    dataLayer,
  ];
}
